module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_michigan-60785f774284dd7ca84c1f443e6e0e90.png";